module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "duration": 1000
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "col-md-12 col-md-offset-5",
    staticStyle: {
      "position": "absolute",
      "top": "0"
    }
  }, [_c('br'), _c('br'), _c('br'), _vm._v(" "), _c('i', {
    staticClass: "fa fa-refresh fa-spin fa-2x fa-fw"
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Loading...")])])]), _vm._v(" "), (!_vm.loading) ? _c('div', [_c('CarehomeHeader', {
    attrs: {
      "carehome-id": _vm.carehomeid,
      "carehome-name": _vm.carehomeDto.name
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tab-content col-md-12"
  }, [_c('div', {
    staticClass: "tab-pane fade active in",
    attrs: {
      "id": "patients"
    }
  }, [_c('br'), _vm._v(" "), _c('carehomepatientlist', {
    attrs: {
      "carehomeid": _vm.carehomeid
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "wards"
    }
  }, [_c('br'), _vm._v(" "), _c('carehomewardlist', {
    attrs: {
      "carehomeid": _vm.carehomeid
    }
  })], 1)])], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "#patients",
      "data-toggle": "tab"
    }
  }, [_vm._v("Patients")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#wards",
      "data-toggle": "tab"
    }
  }, [_vm._v("Wards")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-537cd52e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-537cd52e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/carehome/main/carehome-main.scp.html
// module id = 545
// module chunks = 0